import { StatusPip, Tile } from '@diwata/ironvale'
import type { ClientsFeed } from '@/api/feeds'
import { UnavailableNote, worstItemStatus } from './shared'

/**
 * Diwata-Works engagements — honesty about record gaps first ("no scope note =
 * no sprint"). A client with shipped work but placeholder records is RED with
 * the gap named. Deep links go to the client dir.
 */
export function ClientsTile({ feed }: { feed: ClientsFeed }) {
  const status = worstItemStatus(feed, (feed.items ?? []).map((i) => i.status))
  return (
    <Tile title="Clients" status={status} asOf={feed.asOf}>
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <>
          <div className="ap-client-rows">
            {feed.items.map((client) => (
              <div key={client.client} className="ap-client">
                <a className="ap-tile-row" href={client.link} target="_blank" rel="noreferrer">
                  <StatusPip status={client.status === 'ok' ? 'ok' : client.status} label={`${client.name} ${client.status}`} />
                  <span className="ap-row-name">{client.name}</span>
                  <span className="ap-row-value">
                    {client.sprints_total > 0
                      ? `${client.sprints_paid}/${client.sprints_total} paid`
                      : client.model ?? ''}
                  </span>
                  <span className="ap-row-meta ap-mono">
                    {client.last_log_date ? `log ${client.last_log_date}` : 'no log'}
                  </span>
                </a>
                {client.gaps.length > 0 && (
                  <ul className="ap-gap-list">
                    {client.gaps.map((gap) => (
                      <li key={gap}>{gap}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
          {(feed.studio_deadlines?.length ?? 0) > 0 && (
            <div className="ap-deadlines">
              {feed.studio_deadlines.map((d) => (
                <div key={`${d.date}:${d.text}`} className="ap-deadline">
                  <span className="ap-mono">{d.date}</span> {d.text}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </Tile>
  )
}
